import { z } from 'zod';

import { fastApi } from '@/services/api';

const PATH = 'v1/customer/notification';

export enum NotificationKey {
  JURISDICTION_OPENING = 'jurisdiction-opening',
  FUTURES_APPROPRIATENESS_TEST_RETAKE = 'futures-appropriateness-test-retake',
}

const baseNotificationSchema = z.object({
  email: z.email(),
});

const scheduledNotificationSchema = baseNotificationSchema.extend({
  scheduledDate: z.number(),
});

const scheduledNotificationKeys = [NotificationKey.FUTURES_APPROPRIATENESS_TEST_RETAKE] as const;

type ScheduledNotificationSchema = z.infer<typeof scheduledNotificationSchema>;
type ScheduledNotificationKeys = (typeof scheduledNotificationKeys)[number];

const additionalDataNotificationSchemas = {
  [NotificationKey.JURISDICTION_OPENING]: baseNotificationSchema.extend({
    residencyCountry: z.string(),
  }),
} satisfies Partial<Record<NotificationKey, z.ZodObject>>;

type NotificationSchemas = typeof additionalDataNotificationSchemas;
type BaseNotificationSchema = z.infer<typeof baseNotificationSchema>;

export type NotificationPostRequestBody<K extends NotificationKey> = K extends keyof NotificationSchemas
  ? z.infer<NotificationSchemas[K]>
  : K extends ScheduledNotificationKeys
    ? ScheduledNotificationSchema
    : BaseNotificationSchema;

export const postNotification = <K extends NotificationKey>(key: K, body: NotificationPostRequestBody<K>) => {
  return fastApi.post(`${PATH}/${key}`, {
    json: body,
  });
};
